import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, User, Menu, X, LogOut, Shield } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ cartCount = 0 }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, isAdmin, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-black">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="text-2xl lg:text-3xl font-black tracking-tighter hover:opacity-70 transition-opacity">
            BORNFROMSHINE
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-12">
            <Link to="/catalog" className="text-sm font-bold tracking-wider hover:opacity-50 transition-opacity">
              SHOP
            </Link>
            <Link to="/catalog?category=outerwear" className="text-sm font-bold tracking-wider hover:opacity-50 transition-opacity">
              OUTERWEAR
            </Link>
            <Link to="/catalog?category=tops" className="text-sm font-bold tracking-wider hover:opacity-50 transition-opacity">
              TOPS
            </Link>
            <Link to="/catalog?category=bottoms" className="text-sm font-bold tracking-wider hover:opacity-50 transition-opacity">
              BOTTOMS
            </Link>
            <Link to="/catalog?category=accessories" className="text-sm font-bold tracking-wider hover:opacity-50 transition-opacity">
              ACCESSORIES
            </Link>
          </nav>

          {/* Icons */}
          <div className="flex items-center gap-6">
            {isAdmin && (
              <button
                onClick={() => navigate('/admin')}
                className="hover:opacity-50 transition-opacity hidden lg:block"
                aria-label="Admin Panel"
                title="Admin Panel"
              >
                <Shield size={22} strokeWidth={2.5} />
              </button>
            )}
            
            {user ? (
              <button
                onClick={handleLogout}
                className="hover:opacity-50 transition-opacity"
                aria-label="Logout"
                title="Logout"
              >
                <LogOut size={22} strokeWidth={2.5} />
              </button>
            ) : (
              <button
                onClick={() => navigate('/auth')}
                className="hover:opacity-50 transition-opacity"
                aria-label="Account"
              >
                <User size={22} strokeWidth={2.5} />
              </button>
            )}
            
            <button
              onClick={() => navigate('/cart')}
              className="relative hover:opacity-50 transition-opacity"
              aria-label="Cart"
            >
              <ShoppingBag size={22} strokeWidth={2.5} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-black text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden hover:opacity-50 transition-opacity"
              aria-label="Menu"
            >
              {mobileMenuOpen ? <X size={24} strokeWidth={2.5} /> : <Menu size={24} strokeWidth={2.5} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-black">
          <nav className="flex flex-col px-6 py-8 gap-6">
            <Link
              to="/catalog"
              className="text-2xl font-black tracking-tighter hover:opacity-50 transition-opacity"
              onClick={() => setMobileMenuOpen(false)}
            >
              SHOP
            </Link>
            <Link
              to="/catalog?category=outerwear"
              className="text-2xl font-black tracking-tighter hover:opacity-50 transition-opacity"
              onClick={() => setMobileMenuOpen(false)}
            >
              OUTERWEAR
            </Link>
            <Link
              to="/catalog?category=tops"
              className="text-2xl font-black tracking-tighter hover:opacity-50 transition-opacity"
              onClick={() => setMobileMenuOpen(false)}
            >
              TOPS
            </Link>
            <Link
              to="/catalog?category=bottoms"
              className="text-2xl font-black tracking-tighter hover:opacity-50 transition-opacity"
              onClick={() => setMobileMenuOpen(false)}
            >
              BOTTOMS
            </Link>
            <Link
              to="/catalog?category=accessories"
              className="text-2xl font-black tracking-tighter hover:opacity-50 transition-opacity"
              onClick={() => setMobileMenuOpen(false)}
            >
              ACCESSORIES
            </Link>
            {isAdmin && (
              <Link
                to="/admin"
                className="text-2xl font-black tracking-tighter hover:opacity-50 transition-opacity"
                onClick={() => setMobileMenuOpen(false)}
              >
                ADMIN PANEL
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
